import { render, staticRenderFns } from "./ProductOptions.vue?vue&type=template&id=885bbf7c"
import script from "./ProductOptions.vue?vue&type=script&lang=js"
export * from "./ProductOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports